<template>
  <div class="sv sv014">
    <div class="container">
      <breadcrumb-group :items="breadcrumbItems"/>

      <contents-header class="-orange" src="sv014/main.jpg">
        <p class="heading1">auサービスでもっとおトクに！</p>
        <h1 class="heading2">auでんきでスマートに省エネ！<br>Pontaポイントもたまる！</h1>
      </contents-header>
    </div>

    <div class="container">
      <contents-intro
        class="-orange _pt-sm-60"
        icon-left="sv014/avatar-a.gif"
        name-left="Aさん"
        icon-right="sv014/avatar-b.gif"
        name-right="Bさん"
        txt-relation="同僚の2人">
        最近一人暮らしを始めたBさん。家賃に光熱費など、想像以上にお金がかかるり悩んでいる様子。<br>
        そんなBさんに、節約が趣味のAさんがアドバイスしてくれて…。
      </contents-intro>
    </div>

    <hr class="-pcnone _mb-sm-60">

    <div class="container">

      <heading-two class="_mt-md-110 _mt-sm-60">auスマホやau ひかりとセットでPontaポイントがたまる！</heading-two>

      <talk-group class="_mb-md-60 _mb-sm-40">
        <talk-box src="sv014/avatar-b.gif">はあ…</talk-box>
        <talk-box src="sv014/avatar-a.gif">何だか浮かない顔してるね、どうしたの？</talk-box>
        <talk-box src="sv014/avatar-b.gif">最近一人暮らしを始めたんだけど、家賃とか光熱費とか…色々とお金がかかって大変なんだ…</talk-box>
        <talk-box src="sv014/avatar-a.gif">Bさんってauユーザーだよね？『auでんき』って知ってる？</talk-box>
        <talk-box src="sv014/avatar-b.gif">CMで見たことはあるけど詳しくは知らないな</talk-box>
        <talk-box src="sv014/avatar-a.gif">
          auスマホやauひかりを利用している人がauでんきに加入すると、毎月の電気料金に応じてPontaポイントが還元されるんだ！たまったPontaポイントは普段のお買い物や、auの利用料金の支払いにも使えるから便利でおトクだよ！<br>
          <a href="https://www.au.com/electricity/?bid=we-com-autopsv-0007" target="_blank" class="-next -link">条件など詳しくはこちら</a> ＞
        </talk-box>
        <talk-box src="sv014/avatar-b.gif">ポイントがたまるのは嬉しい！毎月どのくらいたまるのかしら？</talk-box>
        <talk-box src="sv014/avatar-a.gif">
          詳しくは、auでんきのWEBサイトをチェックしてみるといいよ！<br>
          <a href="https://www.au.com/electricity/?bid=we-com-autopsv-0007" target="_blank" class="-next -link">詳しくはこちら</a> ＞
        </talk-box>
      </talk-group>

      <heading-two class="_mt-md-110 _mt-sm-60">「auでんきアプリ」なら気軽に省エネ・節約ができる！</heading-two>

      <talk-group src="sv014/img01.jpg" class="_mb-md-60 _mb-sm-40">
        <talk-box src="sv014/avatar-a.gif">少しでも節約したいなら『auでんきアプリ』もおすすめだよ。毎日の電気使用量が細かくチェックできて、賢く省エネできるんだ！しかも、プッシュ通知で電気の使いすぎも教えてくれるよ</talk-box>
        <talk-box src="sv014/avatar-b.gif">省エネでさらに節約もできるのはいいね！</talk-box>
      </talk-group>

      <talk-group class="_mb-md-60 _mb-sm-40">
        <talk-box src="sv014/avatar-a.gif">auでんきに乗り換えれば、利用量に応じてPontaポイントがどんどんたまっていくんだ！</talk-box>
        <talk-box src="sv014/avatar-b.gif">auのサービスって色々あるのね！どんどん使ってPontaポイントを活用しなきゃ！</talk-box>
      </talk-group>
      <div class="_mb-md-60 _mb-sm-40">
        <small>※au PAY スマートローンのご契約・ご利用には審査がございます。審査状況によりご希望に添えない場合がございますので、あらかじめご了承ください。</small>
      </div>

      <div class="container">
        <btngroup-single class="_mb-md-60 _mb-sm-40">
          <btn-main class="-normal -lg" routerName="sv002">
            au PAY スマートローンの特徴について
          </btn-main>
        </btngroup-single>
      </div>
      <list-group class="_mb-md-120 _mb-sm-60">
        <list-item class="normal">au PAY スマートローンは、au回線をお持ちでない方でもご利用いただけます。</list-item>
        <list-item class="normal"><a href="https://loan.kddi-fs.com/apply" class="-next -link">詳しいお申し込み条件はこちら ＞</a></list-item>
      </list-group>
      <cv-box class="-cv _mb-md-120 _mb-sm-60"/>
    </div>

    <hr class="_mb-120 _mb-sm-60" />

    <div class="container">
      <heading-two>おすすめ記事</heading-two>

      <card-groups class="-image-top-list">
        <card-box router-name="sv013" class="-image-top">
          <card-header>
            <card-image class="-orange"><img src="@/assets/images/sv/sv013/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">携帯電話の料金を見直しておトクに節約！</h3>
          </card-header>
          <card-body>お給料日前は毎月ピンチ…節約を考えるなら、まずは「固定費」を見直してみよう。</card-body>
        </card-box>
        <card-box router-name="sv016" class="-image-top">
          <card-header>
            <card-image class="-orange"><img src="@/assets/images/sv/sv016/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">Pontaポイントでスマートな暮らしを！？</h3>
          </card-header>
          <card-body>お借り入れ方法は、au PAY 残高へのチャージがおすすめ！Pontaポイントをためて賢く暮らそう！</card-body>
        </card-box>
        <card-box router-name="sv011" class="-image-top">
          <card-header>
            <card-image class="-green"><img src="@/assets/images/sv/sv011/thumb.jpg" class="img-fluid" alt=""></card-image>
            <h3 class="heading">ローンっていくら借りられるんだろう？</h3>
          </card-header>
          <card-body>借り入れできる金額には制限があるんです！「いつのまにか借りすぎてしまうことってないかな…？」なんて方はこちら。</card-body>
        </card-box>
      </card-groups>

    </div><!-- container -->
  </div>
</template>

<script>
import ContentsHeader from '../components/contents/ContentsHeader'
import ContentsIntro from '../components/contents/ContentsIntro'
import HeadingTwo from '../components/heading/HeadingTwo'
import TalkGroup from '../components/contents/TalkGroup'
import TalkBox from '../components/contents/TalkBox'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'
import CvBox from '../components/box/CvBox'
import CardGroups from '../components/card/CardGroups'
import CardHeader from '../components/card/CardHeader'
import CardImage from '../components/card/CardImage'
import CardBody from '../components/card/CardBody'
import CardBox from '../components/card/CardBox'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
export default {
  name: 'Sv-014',
  metaInfo: {
    title: 'auでんきでスマートに省エネ！Pontaポイントも貯まる！｜auサービスでもっとおトクに！',
    meta: [
      {name: 'description', content: 'auサービスでおトクに！auでんきを活用して節約する方法について。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,au でんき,省エネ'}
    ]
  },
  components: {
    CardBox,
    CardBody,
    CardImage,
    CardHeader,
    CardGroups,
    CvBox,
    BtnMain,
    BtngroupSingle,
    TalkBox,
    TalkGroup,
    HeadingTwo,
    ContentsIntro,
    ContentsHeader,
    ListGroup,
    ListItem
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'root'
      },
      {
        text: '知っておきたい！ローンについて',
        routerName: 'sv003'
      },
      {
        text: 'auサービスでもっとおトクに！',
        routerName: 'sv044'
      },
      {
        text: 'auでんきでスマートに省エネ！Pontaポイントもたまる！',
        active: true
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/stylesheets/styles";

.contents-card {
  >.card-body {
    background-color: #fff;
    border-radius: 10px;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 30px;
    @include mq-up(md) {
      padding-left: 50px !important;
      padding-right: 50px !important;
    }
    >.txt01 {
      font-size: 12px;
      word-break:break-all;
      @include mq-up(md) {
        margin-bottom: 25px;
        font-size: 14px;
      }
    }
    >.card-groups {
      >.card-box {
        >.card-body {
          >.list-group {
              margin-bottom: 0;
              padding-left: 0;
            >.list-item {
              display: flex;
              align-items: flex-start;
              list-style: none;
              @include mq-up(md) {
                align-items: center;
              }
              img {
                width: 15px;
                margin-right: 5px;
                @include mq-down(md){
                  margin-top: 3px;
                }
                @include mq-up(md) {
                  width: 24px;
                  margin-right: 10px;
                }
              }
            }
          }
        }
      }
    }
  }
}

a {
  &.-link {
    &:hover {
      text-decoration: underline;
      color: $orange;
    }
  }
}

.heading2 {
  > br {
    @include mq-down(xs) {
      display: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Sv014.vue